import { HighPriorityNovaModalContainer } from "@nova/component-nova-modal-container"
import { FunctionComponent } from "react"
import { useCreateMaintenanceRecord } from "features/pilot-tracking/maintenance/MaintenanceRecordQueries"
import { MaintenanceRecordForm, MaintenanceRecordFormValues } from "./MaintenanceRecordForm"

interface AddMaintenanceRecordModalProps {
    aircraftId: string
    templateId: string
    templateInstructions: string | null
    onClose: () => void
}

const AddMaintenanceRecordModal: FunctionComponent<AddMaintenanceRecordModalProps> = ({
    aircraftId,
    templateId,
    templateInstructions,
    onClose,
}) => {
    const { createMaintenanceRecord, isMutating } = useCreateMaintenanceRecord()

    const handleSubmit = async ({
        date_performed,
        performed_by,
        notes,
        skipped,
    }: MaintenanceRecordFormValues) => {
        await createMaintenanceRecord({
            aircraft_id: aircraftId,
            template_id: templateId,
            date_performed,
            performed_by: performed_by || null,
            notes: notes || null,
            skipped,
        })
        onClose()
    }

    return (
        <HighPriorityNovaModalContainer
            className="max-w-xl w-full"
            title="Record Maintenance"
            closeModal={onClose}
        >
            <MaintenanceRecordForm
                templateInstructions={templateInstructions}
                onSubmit={handleSubmit}
                onCancel={onClose}
                isSubmitting={isMutating}
            />
        </HighPriorityNovaModalContainer>
    )
}

export { AddMaintenanceRecordModal }
